import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowUp } from '@fortawesome/free-solid-svg-icons'

interface ScrollToTopButtonProps {
  show: boolean
  onClick: () => void
}

export default function ScrollToTopButton({ show, onClick }: ScrollToTopButtonProps) {
  if (!show) return null

  return (
    <button
      onClick={onClick}
      className='fixed bottom-14 right-2 z-50 w-5 h-14 bg-blue-500/60 hover:bg-blue-600 text-white rounded-full shadow-sm transition-all duration-200 flex items-center justify-center'
      title='Scroll to top'
      aria-label='Scroll to top'
    >
      <FontAwesomeIcon icon={faArrowUp} className='text-xs' />
    </button>
  )
}
